import UIStore from '~/state/ui';

import isBreakpointOrGreater from './isBreakpointOrGreater';

const isNotSmall = () =>
  isBreakpointOrGreater(UIStore.getState().breakpoint, 'md');

export default isNotSmall;
